import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flagVideo
    ? _c(
        VRow,
        {
          staticStyle: {
            "margin-right": "2% !important",
            "margin-left": "2% !important",
          },
        },
        [
          _vm.has_videos()
            ? _c(
                "div",
                { staticClass: "text-center d-flex flex-column align-center " },
                [
                  _c(VImg, {
                    attrs: {
                      src: require("@/assets/icons/states/empty_state.png"),
                      "max-height": "350",
                      "max-width": "500",
                    },
                  }),
                  _c("h2", [_vm._v(_vm._s("Aun no se han cargado videos."))]),
                  _c(
                    VRow,
                    { staticClass: "justify-center" },
                    [
                      _c(VCol, { attrs: { cols: "9" } }, [
                        _c("h6", [_vm._v(_vm._s(""))]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.videos, function (item) {
            return item.module == _vm.modulevid
              ? _c(
                  VCol,
                  { staticClass: "mt-6 col-12 col-sm-6 col-md-4" },
                  [
                    _c(
                      VCard,
                      {
                        attrs: {
                          "max-height": "250px",
                          outlined: "",
                          tile: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openYoutube(item)
                          },
                        },
                      },
                      [
                        _c(VImg, {
                          attrs: {
                            "align-end": "",
                            "max-height": "160px",
                            src: require("@/assets/video_" +
                              _vm.modulevid +
                              ".png"),
                          },
                        }),
                        _c(
                          VCardText,
                          { staticClass: "justify-center headerClass" },
                          [_vm._v(_vm._s(item.titulo))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e()
          }),
        ],
        2
      )
    : !_vm.flagVideo
    ? _c(
        "div",
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.flagVideo = true
                    },
                  },
                },
                [_c(VIcon, [_vm._v("mdi-arrow-left")]), _vm._v("Volver")],
                1
              ),
              _c("iframe", {
                attrs: {
                  width: "100%",
                  height: "500",
                  src: _vm.actualVideo.link,
                  frameborder: "0",
                },
              }),
            ],
            1
          ),
          _c(
            VCol,
            [
              _c(
                VRow,
                [
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c("h1", [_vm._v(_vm._s(_vm.actualVideo.titulo))]),
                    _vm._v(_vm._s(_vm.actualVideo.description)),
                  ]),
                  _c(
                    VCol,
                    [
                      _c(
                        VTooltip,
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var attrs = ref.attrs
                                var on = ref.on
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { outlined: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.shareVideo()
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, { attrs: { small: "" } }, [
                                        _vm._v("mdi-share-variant-outline"),
                                      ]),
                                      _vm._v("Share"),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Clic to copy")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }